import { render } from "./StatTable.vue?vue&type=template&id=367879f5"
import script from "./StatTable.vue?vue&type=script&lang=js"
export * from "./StatTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__